import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { Controller, useForm, useFormContext } from 'react-hook-form'

export const FeatureForm = ({ feature, specificationIndex, featureIndex }) => {
  const { register, handleSubmit, setValue, getValues, control } = useFormContext()

  const addNewFeature = (data) => {
    console.log(data)
  }


  const buildValue = () => {
    if (!feature) {
      return null
    }
    if (feature.type === 'ENUM') {
      return <div>
        <div>Варианты:</div>
        {feature.values.map((value, index) => {
          return <div key={index}>
            <input type='text' {...register(`specifications[${specificationIndex}][features[${featureIndex}]][values[${index}]`)} required />
            <Button type="button" onClick={() => {
              const values = getValues(`specifications[${specificationIndex}][features[${featureIndex}]][values`)
              values.splice(index, 1)
              setValue(`specifications[${specificationIndex}][features[${featureIndex}]][values`, values)
            }}>Удалить</Button>
          </div>
        })}
        <Button type="button" onClick={() => {
          setValue(`specifications[${specificationIndex}][features[${featureIndex}]][values[${feature.values.length}]`, '')
        }}>Добавить новое значение</Button>
      </div>
    }
  }

  return (
    <div style={{ border: "1px solid #ccc", padding: "1rem", marginBottom: "1rem" }}>
      <div className="app-form">
        <div className="m-b-16">
          <strong>{featureIndex + 1}. Свойство: {feature.name}</strong>
        </div>
        <TextField label="Название" {...register(`specifications[${specificationIndex}][features[${featureIndex}]][name]`)} />
        {/* Code */}
        <TextField label="Код" {...register(`specifications[${specificationIndex}][features[${featureIndex}]][code]`)} />
        <Controller fullWidth control={control} name={`specifications[${specificationIndex}][features[${featureIndex}]][type]`} render={({ field }) => {
          return <FormControl fullWidth>
            <InputLabel>Тип</InputLabel>
            <Select label="Тип" {...field} onChange={(e) => {
              setValue(`specifications[${specificationIndex}][features[${featureIndex}]][values]`, [])
              setValue(`specifications[${specificationIndex}][features[${featureIndex}]][type]`, e.target.value)
            }}>
              <MenuItem value="STRING">Строка</MenuItem>
              <MenuItem value="ENUM">Список</MenuItem>
              <MenuItem value="BOOLEAN">Флажок</MenuItem>
            </Select>
          </FormControl>
        }}>
        </Controller>
        {buildValue()}
      </div>
      <div className="m-b-16">
        <Button variant="text" className="m-b-16" onClick={() => {
          const features = getValues(`specifications[${specificationIndex}][features`)
          features.splice(featureIndex, 1)
          setValue(`specifications[${specificationIndex}][features`, features)
        }}>Удалить свойство</Button>
      </div>
    </div>
  )
}
